import React, { Component } from 'react'
import { database } from '../../firebase'
import { ref, child, get, set, update, query, orderByChild, equalTo } from 'firebase/database'
import { withRouter } from '../../withRouter'
import Title from '../components/Title'
import PartidosScores from '../modules/PartidosScores'
import { GroupText, GroupNumber, GroupSwitch, GroupCustom } from '../forms/Groups'
import { ButtonPrimary, ButtonSecondary } from '../components/Buttons'
import { StatusSuccess, StatusError } from '../forms/Status'
import Loading from '../components/Loading'
import setScores from '../../scores'
import './EditId.css'

class EditInterior extends Component {
  constructor (props) {
    super(props)
    this.state = {
      fecha: '',
      actual: false,
      active: false,
      desde: '',
      hasta: '',
      results: [],
      error: null,
      status: '',
      success: '',
      saving: false,
      loaded: false
    }
    this.handleFecha = this.handleFecha.bind(this)
    this.handleActual = this.handleActual.bind(this)
    this.handleDesde = this.handleDesde.bind(this)
    this.handleHasta = this.handleHasta.bind(this)
    this.handleActive = this.handleActive.bind(this)
    this.handleGLocal = this.handleGLocal.bind(this)
    this.handleGVisitante = this.handleGVisitante.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.dbRefQ = ref(database, 'quinielas')
    this.dbRefG = ref(database, 'grupos')
  }
  componentDidMount () {
    this.mode = this.props.match.params.mode
    this.id = this.props.match.params.id
    let fecha, actual, active, desde, hasta, rows
    get(child(this.dbRefQ, 'index/' + this.mode + '/' + this.id))
      .then((snap) => {
        fecha = snap.val().fecha
        actual = snap.val().current
        active = snap.val().active
        desde = snap.val().desde
        hasta = snap.val().hasta
        return get(child(this.dbRefQ, 'partidos/' + this.mode + '/' + this.id))
      })
      .then((snap) => {
        rows = snap.val()
        return get(child(this.dbRefQ, 'resultados/' + this.mode + '/' + this.id))
      })
      .then((snap) => {
        if (snap.val()) {
          this.results = snap.val()
        } else if (rows && Array.isArray(rows)) {
          this.results = rows.map((row) => ({
            local: row.local,
            localId: row.localId,
            gLocal: '',
            visitante: row.visitante,
            visitanteId: row.visitanteId,
            gVisitante: ''
          }))
        } else {
          this.results = []
        }
        this.setState({
          fecha: fecha,
          actual: actual,
          active: active,
          desde: desde,
          hasta: hasta,
          results: this.results,
          loaded: true
        })
      })
      .catch((err) => {
        console.error(err)
      })
  }
  handleFecha (ev) {
    this.setState({
      fecha: ev.target.value,
      error: null,
      status: ''
    })
  }
  handleActual (ev) {
    this.setState((prevState) => ({
      actual: !prevState.actual
    }))
  }
  handleDesde (ev) {
    this.setState({
      desde: ev.target.value,
      status: '',
      error: null
    })
  }
  handleHasta (ev) {
    this.setState({
      hasta: ev.target.value,
      status: '',
      error: null
    })
  }
  handleActive (ev) {
    this.setState((prevState) => ({
      active: !prevState.active
    }))
  }
  handleGLocal (value, index) {
    this.results[index].gLocal = value !== '' ? Number(value) : ''
    this.setState({
      results: this.results
    })
  }
  handleGVisitante (value, index) {
    this.results[index].gVisitante = value !== '' ? Number(value) : ''
    this.setState({
      results: this.results
    })
  }
  handleSubmit (ev) {
    ev.preventDefault()
    if (this.state.fecha === '') {
      this.setState({
        error: 'fecha',
        status: 'No olvides definir la fecha de esta quiniela.'
      })
    } else if (this.state.desde === '') {
      this.setState({
        error: 'desde',
        status: 'Necesitas especificar el inicio de la jornada.'
      })
    } else if (this.state.hasta === '') {
      this.setState({
        error: 'hasta',
        status: 'Necesitas especificar el cierre de la jornada.'
      })
    } else {
      this.setState({
        saving: true
      })
      const updates = {}
      updates['/index/' + this.mode + '/' + this.id] = {
        fecha: this.state.fecha,
        current: this.state.actual,
        active: this.state.active,
        desde: Number(this.state.desde),
        hasta: Number(this.state.hasta)
      }
      updates['/resultados/' + this.mode + '/' + this.id] = this.state.results
      if (this.state.actual) {
        let quinielas = []
        const promises = []
        const currentQuery = query(
          child(this.dbRefQ, 'index/' + this.mode),
          orderByChild('current'),
          equalTo(true)
        )
        get(currentQuery)
          .then((snap) => {
            snap.forEach((child) => {
              quinielas.push(child.key)
            })
            quinielas = quinielas.filter((id) => id !== this.id)
            quinielas.forEach((id, i) => {
              promises[i] = set(child(this.dbRefQ, 'index/' + this.mode + '/' + id + '/current'), false)
            })
            return Promise.all(promises)
          })
          .then(() => {
            return update(this.dbRefQ, updates)
          })
          .then(() => {
            return setScores(this.id, this.mode, this.state.results)
          })
          .then(() => {
            this.setState({
              success: 'Quiniela guardada correctamente.'
            })
            setTimeout(() => this.props.history.push('/edit/' + this.mode), 2000)
          })
          .catch((err) => {
            this.setState({
              saving: false,
              status: err.message || 'Error al guardar la quiniela',
              error: true
            })
          })
      } else {
        update(this.dbRefQ, updates)
          .then(() => {
            return setScores(this.id, this.state.results)
          })
          .then(() => {
            this.setState({
              success: 'Quiniela guardada correctamente.'
            })
            setTimeout(() => this.props.history.push('/edit/' + this.mode), 2000)
          })
          .catch((err) => {
            this.setState({
              saving: false,
              status: err.message || 'Error al guardar la quiniela',
              error: true
            })
          })
      }
    }
  }
  render () {
    if (this.state.loaded) {
      return (
        <div className='edit_id'>
          <Title title='Administrar quiniela' />
          <div className='edit_id__content'>
            <form>
              <div className='edit_id__content__header'>
                <h3>Administra los resultados de la quiniela</h3>
              </div>
              <div className='edit_id__content__body'>
                <GroupText
                  label='Fecha'
                  placeholder='Fecha para identificar esta quiniela'
                  value={this.state.fecha}
                  onChange={this.handleFecha}
                  error={this.state.error === 'fecha'}
                  lg
                />
                <GroupNumber
                  label='Inicio de la jornada'
                  placeholder='Fecha y hora en milisegundos del inicio.'
                  value={this.state.desde}
                  onChange={this.handleDesde}
                  error={this.state.error === 'desde'}
                  lg
                />
                <GroupNumber
                  label='Cierre de la jornada'
                  placeholder='Fecha y hora en milisegundos del cierre.'
                  value={this.state.hasta}
                  onChange={this.handleHasta}
                  error={this.state.error === 'hasta'}
                  lg
                />
                <GroupSwitch
                  label='Actual'
                  value={this.state.actual}
                  onChange={this.handleActual}
                />
                <GroupSwitch
                  label='Activa'
                  value={this.state.active}
                  onChange={this.handleActive}
                />
                <GroupCustom
                  label='Partidos'
                >
                  {this.state.results.map((row, index) => (
                    <PartidosScores
                      {...row}
                      key={index}
                      n={index}
                      handleGLocal={this.handleGLocal}
                      handleGVisitante={this.handleGVisitante}
                    />
                  ))}
                </GroupCustom>
              </div>
              <div className='edit_id__content__footer'>
                <div className='row'>
                  <div className='col-sm-10 col-sm-push-2'>
                    <div className='edit_id__content__footer__row'>
                      <ButtonSecondary
                        onClick={() => this.props.history.push('/edit/' + this.mode)}
                        label='Cancelar'
                      />
                      <ButtonPrimary
                        onClick={this.handleSubmit}
                        label='Guardar'
                        loading={this.state.saving}
                        type='submit'
                      />
                      {this.state.error && <StatusError>{this.state.status}</StatusError>}
                      {this.state.success && <StatusSuccess>{this.state.success}</StatusSuccess>}
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      )
    } else {
      return (
        <div className='edit_id'>
          <Title title='Administrar quiniela' />
          <div className='edit_id__content edit_id__content--loading'>
            <Loading />
          </div>
        </div>
      )
    }
  }
}

export default withRouter(EditInterior)
